<template>
  <div class="landingContentDiv">
    <main class="h-100 w-100">
      <landing-nav-bar />
      <div class="flex flex-column w-100 mainPagePlanes">
        <div class="centerPlanes">
          <div>
            <h5 class="PlanesTitle">{{ $t("landing.planes.title") }}</h5>
            <p class="PlanesText">{{ $t("landing.planes.leyend") }}</p>
            <div class="claseprueba">  
              <div class="claseprueba1 mainPagePlanes freePlan">
                  <div class="bg-Planes">
                    <div class="titleDiv">
                      <h3 class="listTitle"> {{$t("users.userType.free")}} <img src="~@/assets/Landing/planes-icono-rock-white.png"
                          title="Icono Rock" class="rockIcone" /></h3>
                    </div>
                    <div>
                      <ul class="PlanesList">
                        <li>{{ $t("landing.planes.free.text1") }}</li>
                        <li>{{ $t("landing.planes.free.text2") }}</li>
                        <li>{{ $t("landing.planes.free.text3") }}</li>
                      </ul>
                      <br />
                      <p class="PlanesPricing freePricing">{{$t("users.subscription.free")}} </p>
                    </div>
                  </div>
              </div>
              <div class="claseprueba1 mainPagePlanes">
                <div class="bg-Planes">
                  <div class="titleDiv">
                    <h3 class="listTitle"> {{$t("users.userType.musicFan")}} </h3>
                  </div>
                  <div>
                    <ul class="PlanesList">
                      <li>{{ $t("landing.planes.fan.text1") }}</li>
                      <li>{{ $t("landing.planes.fan.text2") }}</li>
                      <li>{{ $t("landing.planes.fan.text3") }}</li>
                      <li>{{ $t("landing.planes.fan.text4") }}</li>
                      <li>{{ $t("landing.planes.fan.text5") }}</li>
                      <li>{{ $t("landing.planes.fan.text6") }}</li>
                    </ul>
                    <br />
                    <p v-if="language === 'es'" class="PlanesPricing">{{$t("users.subscription.currency")}} {{ pricing[0].currency_override.ARS }} </p>
                    <p v-if="language === 'en'" class="PlanesPricing">{{$t("users.subscription.currency")}} {{ pricing[0].amount }} </p>
                  </div>
                </div>
              </div>
              <div class="claseprueba1 mainPagePlanes">
                <div class="bg-Planes ">
                  <div class="titleDiv">
                    <h3 class="listTitle">{{$t("users.userType.producer")}}</h3>
                  </div>
                  <div>
                    <ul class="PlanesList">
                      <li  class="EndTitle">{{ $t("landing.planes.artist.header") }}</li>
                      <li>{{ $t("landing.planes.artist.text1") }}</li>
                      <li>{{ $t("landing.planes.artist.text2") }}</li>
                      <li>{{ $t("landing.planes.artist.text3") }}</li>
                    </ul>
                    <br />
                    <p v-if="language === 'es'" class="PlanesPricing">{{$t("users.subscription.currency")}} {{ pricing[0].currency_override.ARS }} </p>
                    <p v-if="language === 'en'" class="PlanesPricing">{{$t("users.subscription.currency")}} {{ pricing[0].amount }} </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="login" class="buttonContainer">
          <p class="btnPlanesLeft">
            {{ $t("app.signin") }} 
            {{ $t("app.or") }}
            {{ $t("app.signup") }}
          </p>
        </div>
      </div>
      <div class="w-100 claseprueba3">
        <home-footer />
      </div>
    </main>
  </div>
</template>

<script>
  import DirectLinkModal from '@/components/modals/provider/DirectLinkModal.vue'
  import ProviderLink from '@/components/providerLink/ProviderLink.vue'
  import {mapActions, mapGetters} from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import HomeFooter from '@/components/home/HomeFooter.vue'
  import LandingNavBar from './LandingNavBar.vue'

  export default {
    name: 'planes',
    components: {
      ProviderLink,
      DirectLinkModal,
      FontAwesomeIcon,
      HomeFooter,
      LandingNavBar
    },
    methods: {
      ...mapActions('user', [
        'checkUser',
        'loginByMsisdn'
      ]),
      ...mapActions('artist', [
        'getArtist',
        'getArtistTracks',
        'getArtistPlaylists',
        'openProfile',
        'closeProfile'
      ]),
      ...mapActions('pricing', [
        'getPricing'
      ]),
      login () {
        this.$auth0.loginWithRedirect()
      },
      onpopstate (event) {
        // when the state is stored by `beforeRouteUpdate` event, the key is null
        if (this.isProfileOpen && event.state.key !== undefined) {
          this.closeProfile()
        }
      },
      scrollToTop () {
        window.scrollTo(0, 0)
      }
    },
    computed: {
      ...mapGetters('artist', [
        'isProfileOpen',
        'error'
      ]),
      ...mapGetters('user', [
        'authToken',
        'msisdn',
        'provider'
      ]),
      ...mapGetters('translator', [
        'language'
      ]),
      ...mapGetters('pricing', [
        'pricing'
      ])
    },
    created () {
      this.getPricing()
      if (this.authToken) {
        this.checkUser()
      }
      window.onpopstate = this.onpopstate
    },
    mounted () {
      if (this.msisdn) {
        // this.loginByMsisdn({msisdn: this.msisdn, provider: this.provider, enc: true, isValidation: true})
      }
      this.scrollToTop()
    }
  }
</script>

<style lang="scss">
  @import '~@/variables.scss';

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Bold.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Bold.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Bold.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Bold.svg#TitilliumWeb-Bold') format('svg');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Titillium Web';
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot');
    src: url('~@/assets/fonts/TitilliumWeb-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff2') format('woff2'),
    url('~@/assets/fonts/TitilliumWeb-Regular.woff') format('woff'),
    url('~@/assets/fonts/TitilliumWeb-Regular.ttf') format('truetype'),
    url('~@/assets/fonts/TitilliumWeb-Regular.svg#TitilliumWeb-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Humnst777-Blk-BT-Black-Italic';
    src: url('~@/assets/fonts/Humnst777-Blk-BT-Black-Italic.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Montserrat Black';
    src: url('~@/assets/fonts/new_landing/Montserrat-Black.otf');
    font-style: normal;
  }

  @font-face {
    font-family: 'Montserrat Bold';
    src: url('~@/assets/fonts/new_landing/Montserrat-Bold.otf');
    font-weight: bold;
    font-style: normal;
  }

  .ffblack {
    font-family: 'Montserrat Black';
  }

  .ffbold {
    font-family: 'Montserrat Bold';
  }

  .mainPagePlanes{
    background-image: url('~@/assets/Landing/nueva_landing/fondo.jpg');
    background-size: cover;
    background-position: center;
    line-height: initial;
  }

  .claseprueba{
    margin-top: 50px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 100%;
    width: 100%;
  }

  .claseprueba1{
    flex-wrap: wrap;
    width: 25vw;
    height: 63vh;
    border-radius: 15px 15px 15px 15px;
    transform: scaleX(-1);
  }

  .landingContentDiv{
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: white;
    background-color: white;
    height: calc(100vh - 3em - 58px);
  }
  .centerPlanes{
    background-position: center;
    background-size: cover;
    padding-bottom: 5px;
  }
  .PlanesTitle{
    font-size: 60px;
    margin-bottom: auto;
    text-align: center;
    font-family: 'Montserrat Black';
    padding-top: 76px;
  }

  .PlanesText{
    font-family: 'Montserrat Bold';
    font-size: 24px;
    text-align: center;
    margin-left: 60px;
    margin-right: 60px;
  }

  .PlanesPricing{
    font-size: 45px;
    text-align: center;
    color: white;
  }

  .bg-Planes{
    height: 100%;
    width: 100%;
    transform: scaleX(-1);
  }
  .PlanesWidth{
    width: 56.7%;
    margin-top: 50px;
  }
  .PlanesList{
    margin: 45px 15px 45px 0px;
    color:white;
    font-size: 20px;
    text-align: left;
    height: 200px;
    list-style: none;
  }

  .PlanesList li:before {
    content: '✓';
  }
  .titleDiv{
    border-bottom-style: solid;
    border-color: white;
    margin-left: 15px;
    margin-right: 15px;
    text-align: center;
  }
  .listTitle{
    font-size: 25px;
    color: white;
    text-align: center;
    padding: 10px;
    margin: auto;
    font-family: 'Montserrat Black';
  }
  .rockIcone{
    max-width: 5%;
  }
  .EndTitle{
    font-size: 25px;
    color: white;
    justify-content: center;
    margin-bottom: 15px;
  }
  .buttonContainer{
    margin-top: 30px;
    margin-bottom: 30px;
    margin: auto;
  }
  .btnPlanesLeft{
    font-family: 'Montserrat Bold';
    padding-bottom: 10px;
    padding-top: 10px;
    font-size: 25px;
    width: 333px;
    border-radius: 35px 35px 35px 35px;
    outline: 0;
    border-width: 1px;
    border-color: #E6007E;
    background-color: #E6007E;
    color: white;
    outline-offset: 1px;
    text-decoration: none;
    overflow: hidden;
    text-align: center;
    font-weight: bolder;
  }
  .btnPlanesLeft:hover{
    background-color: white !important;
    color: #E6007E !important;
  }

  @media screen and (min-width: 1710px) {
    .claseprueba1 {
      height: 59vh;
    }
  }
  
  @media screen and (min-width: 1000px) and (max-width:1400px) {
    .PlanesPricing{
      font-size: 25px;
      text-align: center;
      position: relative;
      top: 71px;
    }

    .PlanesList{
      margin: 45px 15px 25px 0px;
      color:white;
      font-size: 20px;
      text-align: left;
      height: 200px;
    }

    .claseprueba1{
      flex-wrap: wrap;
      width: 25vw;
      height: 81vh;
      border-radius: 15px 15px 15px 15px;
      transform: scaleX(-1);
    }
  }

  @media screen and (max-width:700px) {

    .mainPagePlanes{
      background-image: url('~@/assets/Landing/nueva_landing/fondo.jpg');
      background-size: cover;
      background-position: center;
      line-height: initial;
    }
    
    .claseprueba{
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      height: 100%;
      width: 100%;
    }

    .claseprueba1{
      margin-top: 15px;
      flex-wrap: wrap;
      width: 80%;
      height: 93vh;
      border-radius: 15px 15px 15px 15px;
      transform: scaleX(-1);
    }

    .freePlan {
      height: 50vh;
    }

    .freePricing {
      top: -156px !important;
    }

    .claseprueba3{
      display: flex;
      margin-top: 20px;
      flex-wrap: wrap;
    }

    .PlanesTitle{
      font-size: 50px;
      margin-bottom: auto;
      text-align: center;
    }

    .PlanesText{
      font-size: 25px;
      text-align: center;
      margin-left: 5px;
      margin-right: 5px;
    }

    .PlanesPricing{
      font-size: 35px;
      text-align: center;
      position: relative;
      top: 125px
    }
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    background-color: $background-color;
    height: 100%;
  }

  a, button, input, select, textarea {
    font-family: 'Titillium Web';
  }

  #app-wrapper {
    font-family: 'Titillium Web', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
    background-color: $background-color;
    height: $main-height;
    width: 100vw;
  }

  .main {
    height: $main-height;
    width: 100vw;
  }

  ul {
    margin: 0;
  }

  .bg-primary {
    background-color: $primary-color;
  }

  .bg-secondary {
    background-color: $secondary-color;
  }

  .bg-accent {
    background-color: $accent-color;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  .primary {
    color: $primary-color;
  }

  .secondary {
    color: $secondary-color;
  }

  .textColor {
    color: $text-color;
  }

  .iconColor {
    color: $icon-color;
  }

  .accent {
    color: $accent-color;
  }
  
  .errorText { 
    color: $error-color;
  }

  .btn {
    border: 0;
    box-sizing: border-box;
    line-height: 2;
    background-color: $primary-color;
    color: white;
  }

  .input {
    box-sizing: border-box;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #DDDEDF;
    background-color: $background-color;
    color: $text-color !important;
  }

  .error {
    border-bottom: 1px solid $error-color;
  }

  .total-height {
    height: $main-height
  }

  .background-center {
    background-position: center center;
  }

  .text-ellipsis {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vinyl-rotation {
    animation: 1.5s linear infinite rotation;
  }

  #style-scroll-bar::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 8px;
    background-color:  #555555;
  }

  #style-scroll-bar::-webkit-scrollbar
  {
    width: 8px;
    background-color: #555555;
  }

  #style-scroll-bar::-webkit-scrollbar-thumb
  {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: $secondary-color;
  }
  @keyframes rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .w-35 {
    width: 35%;
  }

  .w-15 {
    width: 15%;
  }

  .w-7 {
    width: 7%;
  }

  .w-3 {
    width: 3%;
  }

  .w-5 {
    width: 5%;
  }

  .w-95 {
    width: 95%;
  }

  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

  ::placeholder {
    color: $text-color !important;
  }

  .v--modal {
    background-color: $background-color !important;
    color: #aaa !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Landing/Planes.vue